import {makeAutoObservable} from "mobx";

export class RequestStatusStore {
    isLoading: boolean = false;
    abortController: AbortController | null = null;

    constructor() {
        makeAutoObservable(this)
    }

    setIsLoading(value: boolean) {
        this.isLoading = value;
    }

    startRequest(): AbortSignal {
        try { this.abortController?.abort(); } catch {}
        this.abortController = new AbortController();
        this.setIsLoading(true);
        return this.abortController.signal;
    }

    cancelOngoingRequest() {
        try { this.abortController?.abort(); } catch {}
        this.abortController = null;
        this.setIsLoading(false);
    }

    finishRequest() {
        this.abortController = null;
        this.setIsLoading(false);
    }

    isCanceledError(error: any): boolean {
        return !!(
            (error && (error.name === 'CanceledError' || error.code === 'ERR_CANCELED' || error.message === 'canceled')) ||
            (typeof DOMException !== 'undefined' && error instanceof DOMException && error.name === 'AbortError')
        );
    }
}
